import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/175/components/features/cases/OldComponents/cases/zkhfoundation/index.js");
